<!-- eslint-disable vue/no-unused-vars -->
<template>
	<div class="ccris-summary">
		<b-card no-body>
			<b-card-header class="py-2 px-3">
				<h3 class="mb-0">CCRIS Summary</h3>
			</b-card-header>
			<div v-if="tableData.length > 0" class="card-table">
				<el-table :data="tableData" show-summary :summary-method="getSummaries" fit style="width: 100%">
					<el-table-column prop="summary_facility_type" label="Summary Facility Type" min-width="200">
						<template slot="header" slot-scope="scope">
							<span class="text-break">Summary Facility Type</span>
						</template>
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.ccris_sum_loan_label }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="ccris_sum_detected" label="Detected" min-width="100" class-name="text-center">
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.ccris_sum_detected }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="ccris_sum_current_outstanding" label="Total Outstanding Balance (RM)" min-width="160">
						<template slot="header" slot-scope="scope">
							<span class="text-break">{{ scope.column.label }}</span>
						</template>
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.ccris_sum_current_outstanding | moneyFormatter }}</p>
						</template>
					</el-table-column>
					<el-table-column prop="ccris_sum_current_installment" label="Total Commitment (RM)" min-width="170">
						<template slot="header" slot-scope="scope">
							<span class="text-break">{{ scope.column.label }}</span>
						</template>
						<template slot-scope="scope">
							<p class="top-line">{{ scope.row.ccris_sum_current_installment | moneyFormatter }}</p>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else class="bg-light p-3 text-center rounded-bottom">
				<p class="text-xs">No CCRIS Summary recorded</p>
			</div>
		</b-card>
	</div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'

export default {
	name: 'summary-ccris',
	props: ['summary_ccris'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	data() {
		return {
			tableData: this.summary_ccris
		}
	},
	computed: {
	},
	methods: {
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = 'Total';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) {
					const sum = values.reduce((prev, curr) => {
					const value = Number(curr);
					if (!isNaN(value)) {
						return prev + curr;
					} else {
						return prev;
					}
					}, 0);
					sums[index] = index === 1 ? `${sum}` : `RM ${sum.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
				} else {
					sums[index] = 'N/A';
				}
			});

			return sums;
		},
	}
}
</script>